import { useEffect, type ReactNode } from "react"
import { useAuthStore } from "@/shared/hooks/use-auth-store"

interface AuthInitializerProps {
  children: ReactNode
}

export function AuthInitializer({ children }: AuthInitializerProps) {
  const initialize = useAuthStore((s) => s.initialize)

  useEffect(() => {
    const unsubscribe = initialize()
    return () => {
      unsubscribe()
    }
  }, [initialize])

  return <>{children}</>
}
